import { slugRegex } from "../utils/validation";
import { z } from "zod";
const WORKSPACE_NAME_MIN_LENGTH = 2;
const WORKSPACE_NAME_MAX_LENGTH = 64;
export const HANDLE_MIN_LENGTH = 2;
export const HANDLE_MAX_LENGTH = 64;
export const CreateWorkspaceInput = z.object({
    name: z
        .string()
        .min(WORKSPACE_NAME_MIN_LENGTH)
        .max(WORKSPACE_NAME_MAX_LENGTH)
        .trim(),
    handle: z
        .string()
        .regex(slugRegex)
        .min(HANDLE_MIN_LENGTH)
        .max(HANDLE_MAX_LENGTH)
        .refine((value) => (value === null || value === void 0 ? void 0 : value.length) > 0)
        .optional(),
});
